// Force repaint fixes blank screen and elements positioning bug on iPhone

export function forceRepaint() {
  window.scroll(0, -1);
}
